import { render, staticRenderFns } from "./accommodationsView.vue?vue&type=template&id=5b69131f"
import script from "./accommodationsView.vue?vue&type=script&lang=js"
export * from "./accommodationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports